import { addPostTypeFieldGQLMutation, archivePostTypeFieldGQLMutation, deletePostTypeFieldGQLMutation, getPostTypeGQLQuery, getPostTypesGQLQuery, reorderPostTypeFieldsGQLMutation, unarchivePostTypeFieldGQLMutation, updatePostTypeFieldGQLMutation, } from '../../graphql/index.js';
export class PostTypeClient {
    constructor(client) {
        this.client = client;
    }
    async list(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getPostTypesGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.postTypes;
    }
    async get(variables, fields = 'basic') {
        const result = await this.client.authorizedRequest({
            query: getPostTypeGQLQuery(fields),
            variables,
        });
        return result.postType;
    }
    async addField(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: addPostTypeFieldGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.updatePostTypeField;
    }
    async archiveField(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: archivePostTypeFieldGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.archivePostTypeField;
    }
    async deleteField(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: deletePostTypeFieldGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.deletePostTypeField;
    }
    async reorderFields(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: reorderPostTypeFieldsGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.reorderPostTypeFields;
    }
    async unarchiveField(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: unarchivePostTypeFieldGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.unarchivePostTypeField;
    }
    async updateField(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: updatePostTypeFieldGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.updatePostTypeField;
    }
}
//# sourceMappingURL=postType.client.js.map